module.exports = __webpack_public_path__ + "static/media/28DGC5.3783c489.jpg";